import { css } from 'styled-components';
import type { PropsWithTheme } from '../../styled';
import { MOBILE_HEAD_FEATURES_MARGIN } from './constants';
import type { FeatureProps } from './feature';

const dividerMixin = ({
  theme: {
    features: { color }
  }
}: PropsWithTheme) => css`
  content: '';
  display: block;
  position: absolute;
  left: 0;
  height: 1px;
  width: 100%;
  opacity: 0.1;
  background: ${color};
`;

interface StripsMixinProps extends PropsWithTheme {
  $hasHeadFeatures: boolean;
}

const stripsMixin = ({
  $hasHeadFeatures,
  theme: {
    features: { color }
  }
}: StripsMixinProps) => css`
  &:nth-child(${$hasHeadFeatures ? 'even' : 'odd'}):after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.05;
    pointer-events: none;
    background: ${color};
  }
`;

export const getFeaturesBackgroundMixin = ({
  $hasHeadFeatures,
  $isHeadFeature,
  theme: {
    features: { type }
  }
}: PropsWithTheme<FeatureProps>) => {
  if ($isHeadFeature) {
    return;
  }

  if (type === 'divided') {
    return css`
      &:before {
        top: 0;
        ${dividerMixin};
      }

      ${$hasHeadFeatures &&
      css`
        &:after {
          bottom: 0;
          ${dividerMixin};
        }
      `}

      &:last-child:after {
        bottom: -1px;
        ${dividerMixin};
      }
    `;
  }
  if (type === 'striped') {
    return css<FeatureProps>`
      ${stripsMixin};
    `;
  }

  return;
};

export const getHeadFeaturesMarginsMixin = ({
  $isHeadFeature,
  $hasHeadFeatures
}: FeatureProps) => {
  if (!$hasHeadFeatures) {
    return;
  }

  if ($isHeadFeature) {
    return css`
      margin-top: ${MOBILE_HEAD_FEATURES_MARGIN}px;
    `;
  }

  return css`
    margin-bottom: ${MOBILE_HEAD_FEATURES_MARGIN}px;
  `;
};

export const getAlignRowsMarginsMixin = ({
  $alignRows,
  $isLastFeatureRow,
  $outerPaddings: { top, bottom }
}: FeatureProps) =>
  $alignRows &&
  css`
    &:first-child {
      margin-top: ${top}px;
    }

    ${$isLastFeatureRow &&
    css`
      &:last-child {
        margin-bottom: ${bottom}px;
      }
    `}
  `;
